import React from "react";
import LoginForm from "../components/Forms/LoginForm";

// Styling
import "../css/LoginPage.css";

// Login page that holds the login form

class Login extends React.Component {
  render() {
    return (
      <div id = "login-page">
        <LoginForm />
      </div>
    );
  }
}

export default Login;
